import React from "react";
import PropTypes from "prop-types";
import { ErrorHandler } from "../../components";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Обновить состояние с тем, чтобы следующий рендер показал запасной UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Можно также сохранить информацию об ошибке в соответствующую службу журнала ошибок
  }

  render() {
    if (this.state.hasError) {
      // Можно отрендерить запасной UI произвольного вида
      return <ErrorHandler />;
    }

    return this.props.children;
  }
}

AppErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AppErrorBoundary;
